import React from 'react';
import styled, { css } from 'styled-components';

// Components
import { NavLink } from 'react-router-dom';
import { H3 } from '../../title';

// styling
import { colors, spacing } from '../../../style';

const variants = {
  default: css`
    color: ${colors.gray900};
    &:hover {
      background: ${colors.gray100};
    }
    &.active,
    &.active:hover {
      color: ${props => props.theme.actionColor};
    }
    &:focus-visible {
      border: 2px solid ${colors.sky};
    }
  `,
  'action-light': css`
    color: ${colors.gray900};
    &:hover {
      background: ${colors.gray100};
    }
    &.active,
    &.active:hover {
      color: ${colors.gray900};
      background: ${props => props.theme.actionLight};
    }
    &:focus-visible {
      border: 2px solid ${colors.sun};
    }
  `,
  'selected-blue': css`
    color: ${colors.gray100};
    &:hover {
      background: ${colors.selectedBlue};
    }
    &.active,
    &.active:hover {
      color: ${colors.gray100};
      background: ${colors.selectedBlue};
    }
    &:focus-visible {
      border: 2px solid ${colors.sun};
    }
  `,
};

const SideMenuTabItem = styled(
  ({
    to,
    disabled,
    className,
    href,
    children,
    variant,
    componentClass: Component = NavLink,
    ...rest
  }: {
    to?: any;
    href?: any;
    variant?: keyof typeof variants;
    children?: React.ReactNode;
    className?: string;
    disabled?: boolean;
    componentClass?: 'button' | React.ElementType;
  }) => {
    const isLink = to || href;
    return (
      <Component
        to={to || href}
        activeClassName={isLink ? 'active' : undefined}
        className={className}
        disabled={disabled}
        variant={variant}
        {...rest}
      >
        <H3 weight={400} variant={'inherit'} size={'xs'}>
          {children}
        </H3>
      </Component>
    );
  },
)`
  position: relative;
  display: flex;
  height: ${spacing.lg};
  width: 100%;
  text-align: left;
  justify-content: flex-start;
  font-weight: 400;
  text-decoration: none;
  align-items: center;
  border: none;
  background: transparent;
  padding: ${spacing.sm};
  padding-left: ${spacing.md};
  border-radius: 'none';

  ${props => variants[props.variant || 'default']};

  &:last-child:not(:active)::before {
    height: calc(100% - ${spacing.xs});
  }

  & + &:not(:active)::before {
    top: ${spacing.none};
  }
`;

export default SideMenuTabItem;
